
<template>
  <div>
    <div class="row text-left justify-content-center">
      <div class="col-12 col-md-10 col-xl-8 rules">
        <h1 class="my-4">Death Knight Info<img :src="require('@/assets/images/icons/menu/deathknight.png')"/></h1>
          <p>
            When the Lich King's control over his death knights was broken, his former champions found their new purpose as Knights of the Ebon Blade. After Bolvar Fordragon donned the helm to keep the undead Scourge contained, he called forth a new generation of death knights to join the Ebon Blade's cause.
          </p>
          <p>
            Death Knights engage their foes up-close, supplementing swings of their weapons with dark magic that renders enemies vulnerable or damages them with unholy power. They drag foes into one-on-one conflicts, compelling them to focus their attacks away from weaker companions. To prevent their enemies from fleeing their grasp, death knights must remain mindful of the power they call forth from runes, and pace their attacks appropriately.
          </p>
          <p>
            Death Knights utilize two unique resources: runes and runic power. Runes regenerate slowly over time and runic power is generated in the heat of combat by performing successful melee strikes or using particular abilities.
          </p>
      </div>
    </div>
    <div class="row text-left justify-content-center">
      <div class="col-6 col-sm-3 col-md-3 col-xl-2">
        <img :src="require('@/assets/images/races/deathknight.png')" alt="deathknight" class="race-pic" style=""/>
      </div>
      <div class="col-12 col-sm-10 col-md-7 col-xl-6">
        <h1 class="my-4">Death Knight Stat Costs</h1>
        <table class="race-table">
          <th>Stat/Skill</th>
          <th>Cost Per Rank</th>
          <tr>
            <td>Base Stats</td>
            <td>3,000 XP</td>
          </tr>
          <tr>
            <td>Combat Skills</td>
            <td>3,000 XP</td>
          </tr>
          <tr>
            <td>Feats</td>
            <td>3,000 XP</td>
          </tr>
          <tr>
            <td>Abilities</td>
            <td>3,000 XP</td>
          </tr>
          <tr>
            <td>+5 Max HP</td>
            <td>3,000 XP</td>
          </tr>
          <tr>
            <td>+5 Max RP</td>
            <td>3,000 XP</td>
          </tr>
          <tr>
            <td>+4 Max MP</td>
            <td>3,000 XP</td>
          </tr>
          <tr>
            <td>Knowledges</td>
            <td>3,000 XP</td>
          </tr>
          <tr>
            <td>Adventuring Skills</td>
            <td>3,000 XP (per 2 ranks)</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row text-left justify-content-center">
      <div class="col-12 col-md-10 col-xl-8 rules">
        <h1 class="my-4">Death Knight Starting Stats</h1>
          <table class="race-table">
          <th>Stat/Skill</th>
          <th>Starting Value</th>
          <tr>
            <td>Base HP</td>
            <td>50</td>
          </tr>
          <tr>
            <td>Base RP</td>
            <td>100</td>
          </tr>
          <tr>
            <td>Base MP</td>
            <td>4</td>
          </tr>
          <tr>
            <td>Base DP</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Base CP</td>
            <td>0</td>
          </tr>
          <tr>
            <td>Base NEP</td>
            <td>3</td>
          </tr>
          <tr>
            <td>Base HP Regen</td>
            <td>+2/round</td>
          </tr>
          <tr>
            <td>Starting Feats</td>
            <td>3</td>
          </tr>
          <tr>
            <td>Starting Knowledges</td>
            <td>3</td>
          </tr>
          <tr>
            <td>Size Category</td>
            <td>Varies</td>
          </tr>
          <tr>
            <td>Vision</td>
            <td>Darkvision</td>
          </tr>
          <tr>
            <td>Move Speed</td>
            <td>30 feet/move</td>
          </tr>
          <tr>
            <td>Jump</td>
            <td>x2</td>
          </tr>
          <tr>
            <td>Immunities</td>
            <td>
              <ul>
                <li>Virus</li>
                <li>Disease</li>
                <li>Poison</li>
                <li>Space</li>
                <li>Shadow</li>
                <li>Ice/Cold</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>Weaknesses</td>
            <td>
              <ul>
                <li>x1.5 damage from Fire and Magic Fire</li>
                <li>x2 damage from Celestial, Silver and Blue Fire</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>Special Conditions for Death</td>
            <td>
              <ul>
                <li>Decapitation</li>
                <li>Disintegration</li>
                <li>Max HP reduced to 0</li>
              </ul>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row text-left justify-content-center" style="margin-bottom: 30px;">
      <div class="col-12 col-md-10 col-xl-8 rules">
        <h1 class="my-4">Death Knight Specializations</h1>
        <p>
          Blood Death Knights - (Can be selected during character creation)
          <ul>
            <li>+20 Max HP | +2 NEP</li>
            <li>+2 Endurance | +2 Reflex</li>
            <li>HP Cost reduced by -1,000</li>
            <li>Damage taken while below 30% Max HP is reduced by 30%</li>
            <li>Removes your weakness to celestial, and allows you to be healed by celestial-based spells and items</li>
            <li>Unlocks use of 6 Blood Runes and Blood Caster Proficiency</li>
          </ul>
        </p>
        <p>
          Frost Death Knights - (Can be selected during character creation)
          <ul>
            <li>+12 Max MP</li>
            <li>+2 Melee | +2 Focus</li>
            <li>While you have less than 3 full runes available, your melee attacks deal an additional 1d12 frost damage</li>
            <li>Abilities that deal frost damage have a 20% chance to apply Blinding Sleet to the target, causing their next direct attack to have a 20% chance to automatically miss.</li>
            <li>Grants Ice Walk</li>
            <li>Unlocks use of 6 Frost Runes and Frost Caster Proficiency</li>
          </ul>
        </p>
        <p>
          Unholy Death Knights - (Can be selected during character creation)
          <ul>
            <li>+20 Max RP</li>
            <li>+2 Melee | +2 Focus</li>
            <li>Death and Decay now reduces the movement speed of enemies within its area by 1/2 and has a 10% chance to apply a stack of Festering Wound</li>
            <li>Death Coil can now be used to heal you or your Skeleton Familiar for 1/2 of the damage it would deal</li>
            <li>Grants Permanent Skeleton Familiar</li>
            <li>Unlocks use of 6 Unholy Runes and Shadow Caster Proficiency</li>
          </ul>
        </p>
      </div>
    </div>
  </div>
</template>

<style>
.rules > h2 {
  margin-top: 20px;
}


</style>

<script>
export default {
  name: 'DeathknightPage',
  props: {
    app: Object
  },
  computed: {
  }
}
</script>
